var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons-block"},[_c('button',{staticClass:"select",on:{"click":_vm.select}},[_vm._v("\n    "+_vm._s(_vm.$t('common.choose'))+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"reset",on:{"click":_vm.reset}},[_vm._v("\n    "+_vm._s(_vm.$t('common.reset'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }